import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function fetchSystemDashboard() {
    const res = await axios.get(buildApiUrl("/System/dashboard"));
    return res.data;
}

export async function fetchSystemSchools(params = {}) {
    const res = await axios.get(buildApiUrl("/System/schools"), { params });
    return res.data;
}

export async function fetchSystemSchool(schoolId) {
    const res = await axios.get(buildApiUrl(`/System/schools/${schoolId}`));
    return res.data;
}

export async function updateSystemSchool(schoolId, fields) {
    const res = await axios.put(buildApiUrl(`/System/schools/${schoolId}`), fields);
    return res.data;
}

export async function updateSchoolSubscription(schoolId, payload) {
    const res = await axios.put(buildApiUrl(`/System/schools/${schoolId}/subscription`), payload);
    return res.data;
}

export async function approveTrialExtension(schoolId, days) {
    return updateSchoolSubscription(schoolId, {
        action: "approve_trial_extension",
        ...(days ? { days } : {}),
    });
}

export async function rejectTrialExtension(schoolId) {
    return updateSchoolSubscription(schoolId, { action: "reject_trial_extension" });
}

export async function approveSchoolVerification(schoolId) {
    return updateSchoolSubscription(schoolId, { action: "approve_verification" });
}

export async function rejectSchoolVerification(schoolId) {
    return updateSchoolSubscription(schoolId, { action: "reject_verification" });
}

export async function fetchSystemPayments(params = {}) {
    const res = await axios.get(buildApiUrl("/System/payments"), { params });
    return res.data;
}

export function subscriptionStatusColor(status) {
    const s = String(status || "").toLowerCase();
    if (s === "active" || s === "lifetime") return "success";
    if (s === "trialing") return "info";
    if (s === "pending_verification" || s === "pending") return "warning";
    if (s === "rejected") return "error";
    if (s === "expired") return "error";
    return "default";
}

export function formatDate(value) {
    if (!value) return "—";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("en-MW", { year: "numeric", month: "short", day: "numeric" });
}
